import * as R from 'ramda';

// eslint-disable-next-line import/prefer-default-export
export const filterNotifications = (notifications, allowedNotificationTypes) => {
  return R.filter(item => allowedNotificationTypes.indexOf(item.typeId) !== -1, notifications);
};
